import { type SolutionProps } from './index'
import homepage from '@/assets/img/solution/solution-2/homepage.jpg'
import solution from '@/assets/img/solution/solution-2/solution.jpg'
import banner from '@/assets/img/solution/solution-2/banner.png'
import solution_image_1 from '@/assets/img/solution/solution-2/solution-image-1.png'
import advantage from '@/assets/img/solution/solution-2/advantage.png'
import application_1 from '@/assets/img/solution/solution-2/application/application-1.png'
import application_2 from '@/assets/img/solution/solution-2/application/application-2.png'
import application_3 from '@/assets/img/solution/solution-2/application/application-3.png'
import application_4 from '@/assets/img/solution/solution-2/application/application-4.png'
import product_1 from '@/assets/img/solution/solution-2/product/product-1.png'
import product_2 from '@/assets/img/solution/solution-2/product/product-2.png'
import successCase_1 from '@/assets/img/solution/solution-2/success-case/success-case-1.png'
import successCase_2 from '@/assets/img/solution/solution-2/success-case/success-case-2.png'
import successCase_3 from '@/assets/img/solution/solution-2/success-case/success-case-3.png'

export const solution_2: SolutionProps = {
  id: 2,
  path: '/solution/distributed-PV&ESS',
  title: 'Distributed PV and ESS (C&I & Residential)',
  description:
    'More participants enjoy the benefits of green energy, collectively reduce carbon emissions, and create a green city.',
  cover: homepage,
  solutionCover: solution,
  banner: banner,
  solution: [solution_image_1],
  advantage: advantage,
  application: [
    {
      title: 'Daily Household Electricity Use',
      description: 'Powers lighting, appliances, air conditioning, heating systems, and more.',
      image: application_1,
    },
    {
      title: 'Remote or Off-Grid Areas',
      description: 'Provides stable electricity to areas without grid coverage.',
      image: application_2,
    },
    {
      title: 'Emergency Backup Power',
      description: 'Offers emergency power support during natural disasters or grid failures.',
      image: application_3,
    },
    {
      title: 'Electric Vehicle Charging',
      description: 'Supplies clean energy for charging household electric vehicles.',
      image: application_4,
    },
  ],
  product: [
    {
      title: 'CARUS-Orion-C01',
      description: '',
      image: product_1,
    },
    {
      title: 'CARUS-Stark100',
      description: '',
      image: product_2,
    },
  ],
  success_case: [
    {
      title: 'successCase_1',
      image: successCase_1,
    },
    {
      title: 'successCase_2',
      image: successCase_2,
    },
    {
      title: 'successCase_3',
      image: successCase_3,
    },
  ],
}
